import { Component, DOMAttributes } from "react"
import { actOnEnterOrSpace } from "../../common/js-utils"
import "./Checkbox.less"
import { getFlagEnabled } from "../../getFlagValue"

type tProps = {
    id?: string
    isChecked: boolean
    onChange: () => void
    disabled?: boolean
}

class StyledCheckbox extends Component<tProps & DOMAttributes<HTMLSpanElement>> {
    render(): JSX.Element {
        const { id, isChecked, onChange, disabled } = this.props
        // when cleaning up the flag, we can just use disabled, and remove isDisabled
        const isDisabled = getFlagEnabled("WA-8890-sig-images-in-tk-pdf") && disabled
        return (
            <span
                id={id ? id : ""}
                className="styled-checkbox"
                onClick={() => !isDisabled && onChange()}
                onKeyDown={e => !isDisabled && actOnEnterOrSpace(e, onChange)}
                tabIndex={0}
                role="checkbox"
                aria-checked={isChecked}
            >
                <input
                    className="styled-checkbox-input"
                    type="checkbox"
                    checked={isChecked}
                    readOnly
                    disabled={isDisabled}
                />
                <span className="styled-checkbox-box"></span>
                <span
                    className={`styled-checkbox-val ${isChecked ? "styled-checkbox-yes" : "styled-checkbox-no"} ${
                        isDisabled ? "styled-checkbox-disabled" : ""
                    }`}
                >
                    {isChecked ? "Yes" : "No"}
                </span>
            </span>
        )
    }
}

export default StyledCheckbox
